import { render, staticRenderFns } from "./HeaderStyleSuperAdmin.vue?vue&type=template&id=7feadc58&"
import script from "./HeaderStyleSuperAdmin.vue?vue&type=script&lang=js&"
export * from "./HeaderStyleSuperAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports